import { useEffect, useState } from 'react';
import { ENV } from '@/lib/env';
/**
 * Fetches GET /auth/me with the stored JWT to determine the current user's role.
 * Returns { role, loading }. During loading, role is null - callers should hide
 * role-gated UI until loading is false.
 *
 * Dev bypass: in development mode, ?__bypass_gate=1 skips the network call and
 * returns role:'developer' immediately (matches DevOnlyGate bypass behavior).
 */
export function useAuthRole() {
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        // Dev bypass - same condition as DevOnlyGate
        if (import.meta.env.DEV &&
            typeof window !== 'undefined' &&
            window.location.search.includes('__bypass_gate=1')) {
            setRole('developer');
            setLoading(false);
            return;
        }
        const url = `${ENV.apiBaseUrl}${ENV.apiPrefix}/auth/me`;
        const token = typeof window !== 'undefined' ? window.localStorage.getItem('lpc.token') : null;
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        fetch(url, { credentials: 'include', headers })
            .then(async (res) => {
            if (!res.ok) {
                setRole(null);
                return;
            }
            const data = (await res.json());
            setRole(data.role ?? null);
        })
            .catch(() => setRole(null))
            .finally(() => setLoading(false));
    }, []);
    return { role, loading };
}
